module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '/*global define*/\n\ndefine("models/Solution", [\n    \'underscore\',\n    \'backbone\'\n], function (_, Backbone) {\n    \'use strict\';\n\n    var SolutionModel = Backbone.Model.extend({\n        defaults: {\n\n        }\n    });\n\n    return SolutionModel;\n});\n';

}
return __p
}